




















import { Vue, Component } from 'vue-property-decorator';
import { Emit, Prop } from '@samclick-commons';

@Component
export default class SamclickSelect extends Vue {
    @Prop({ default: () => [] })
    private items!: any;

    @Prop({ default: '' })
    private value!: string | number;

    @Prop()
    private valueKey?: any;

    @Prop()
    private altValueKey?: any;

    @Prop()
    private labelKey!: any;

    @Prop({ default: false })
    private translate?: boolean;

    @Emit('input')
    change(e:any) {
      return e;
    }

    @Emit('blur')
    blur(e:any) {
      return e;
    }

    @Emit('visible-change')
    visibleChange(visible: boolean) {
      return visible;
    }

    getDisplayValue(item: LooseObject) {
      if (this.$props.translate) {
        return this.$t(item[this.$props.labelKey] ? item[this.$props.labelKey] : item[this.$props.altValueKey]);
      }
      return item[this.$props.labelKey] ? item[this.$props.labelKey] : item[this.$props.altValueKey];
    }

    get defaultAttrs() {
      return {
        size: 'small',
        placeholder: 'Select',
      };
    }

    get overrideAttrs() {
      return Object.assign(this.defaultAttrs, this.$attrs);
    }
}
